import React, { useCallback } from 'react'

import {
  enroll2faAppConfirmPath,
  enroll2faAppPath,
  enroll2faSmsConfirmPath,
  enroll2faSmsPath,
  extensionRedirectPath,
  selectPlanPath,
} from '$extensionSrc/consts/urlConsts'

import Enroll2faAppForm from './Enroll2faAppForm'
import Enroll2faSmsForm from './Enroll2faSmsForm'
import TabToggle from './TabToggle'

import './Enroll2faChooseMethodPage.scss'

export default function Enroll2faChooseMethodPage({
  hasActivePlan,
  initialTab,
  totpCode,
  totpQrcode,
  next,
}: {
  hasActivePlan: boolean
  initialTab: string
  totpCode: string
  totpQrcode: string
  next?: string
}) {
  const onClickConfirm2faApp = useCallback(() => {
    if (!next) {
      window.location.assign(enroll2faAppConfirmPath)
    } else {
      const urlParams = new URLSearchParams()
      urlParams.append('next', next)
      window.location.assign(
        `${enroll2faAppConfirmPath}?${urlParams.toString()}`,
      )
    }
  }, [next])

  const onClickConfirm2faSms = useCallback(() => {
    if (!next) {
      window.location.assign(enroll2faSmsConfirmPath)
    } else {
      const urlParams = new URLSearchParams()
      urlParams.append('next', next)
      window.location.assign(
        `${enroll2faSmsConfirmPath}?${urlParams.toString()}`,
      )
    }
  }, [next])

  const onClickSkip = useCallback(() => {
    window.location.assign(
      next || (hasActivePlan ? extensionRedirectPath : selectPlanPath),
    )
  }, [hasActivePlan, next])

  const onClickSwitchToEnroll2faApp = useCallback(() => {
    if (!next) {
      window.location.assign(enroll2faAppPath)
    } else {
      const urlParams = new URLSearchParams()
      urlParams.append('next', next)
      window.location.assign(`${enroll2faAppPath}?${urlParams.toString()}`)
    }
  }, [next])

  const tabContentMap = {
    sms: {
      content: (
        <Enroll2faSmsForm
          onClickConfirm={onClickConfirm2faSms}
          onClickSkip={onClickSkip}
          onClickSwitchToEnroll2faApp={onClickSwitchToEnroll2faApp}
          showSkip
        />
      ),
      displayName: 'Using SMS',
      url: enroll2faSmsPath,
    },
    app: {
      content: (
        <Enroll2faAppForm
          onClickConfirm={onClickConfirm2faApp}
          onClickSkip={onClickSkip}
          showSkip
          totpCode={totpCode}
          totpQrcode={totpQrcode}
        />
      ),
      displayName: 'Using an app',
      url: enroll2faAppPath,
    },
  }
  return (
    <div className="Enroll2faChooseMethodPage">
      <div className="header">
        <div className="heading1 bold center">Secure your account</div>
        <div className="body1 darkest-gray center">
          Choose how to verify it's you when you log in
        </div>
      </div>
      <TabToggle tabContentMap={tabContentMap} initialTab={initialTab} />
    </div>
  )
}
